<div class="hotel-reservation-container">
  <div class="image-container">
    <app-image [type]="typeImageHotel" [src]="image" [borderRadius]="8"></app-image>
  </div>
  <p class="hotel-name">{{hotelName}}</p>
  <div class="hotel-clasification">
    <div class="stars" *ngIf="hasCategory">
      <i aria-hidden="true" *ngFor="let item of [].constructor(stars)" class="icon-star"></i>
    </div>
    <span *ngIf="hasCategory" class="separator">|</span>
    <span class="destination" [class.has-category]="hasCategory">{{destinationName | capitalize}}</span>
  </div>
  <div class="location">
    <i aria-hidden="true" class="icon-location"></i>
    <span>{{location}}</span>
  </div>

  <div class="hotelReservation__marriott-bonvoy-banner" *ngIf="isMarriottProvider">
    <app-ds-tag-product
      [title]="'HOTELS_MODULE.MARRIOTT.TITLE' | transloco"
      [subtitle]="'HOTELS_MODULE.MARRIOTT.SUBTITLE' | transloco"
      [type]="tagProductType"
      [branding]="brandingTagProduct">
    </app-ds-tag-product>
  </div>

  <hr>
  <ng-container *ngIf="!isByhours; else detailByhours">
    <div class="registration">
      <div class="check-in">
        <app-ds-typography 
          [fontFamily]="fontFamily.SemiBold" 
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [text]="'HOTELS_MODULE.HOTEL_RESERVATION.CHECK_IN' | transloco">
        </app-ds-typography>
        <app-ds-typography 
          [fontFamily]="fontFamily.Regular" 
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [text]="checkinDate | date:'EEEE, d MMM yyyy' | capitalize">
        </app-ds-typography>
      </div>
      <div class="check-out">
        <app-ds-typography 
          [fontFamily]="fontFamily.SemiBold" 
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [text]="'HOTELS_MODULE.HOTEL_RESERVATION.CHECK_OUT' | transloco">
        </app-ds-typography>
        <app-ds-typography 
          [fontFamily]="fontFamily.Regular" 
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [text]="checkoutDate | date:'EEEE, d MMM yyyy' | capitalize">
        </app-ds-typography>
      </div>
    </div>
    <div class="room-and-nights">
      <div class="nights">
        <app-ds-typography 
          [fontFamily]="fontFamily.SemiBold" 
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [text]="'HOTELS_MODULE.RESULT_HOTELS.NIGHTS' | transloco">
        </app-ds-typography>
        <span class="quantity-nights">
          <app-ds-typography 
            [fontFamily]="fontFamily.Regular" 
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [text]="totalNightsNumber + ' ' + (isOneNight | transloco) + ', '">
          </app-ds-typography>
          <app-ds-typography 
            [fontFamily]="fontFamily.Regular" 
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [text]="'USER_HISTORY_MODULE.DETAIL.PASSENGERS.' + getAdultsTranslate | transloco: { quantity: adults }">
          </app-ds-typography>
          <app-ds-typography
            *ngIf="childrens"
            [fontFamily]="fontFamily.Regular" 
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [text]="'USER_HISTORY_MODULE.DETAIL.PASSENGERS.' + getChildrenTranslate | transloco: { quantity: childrens }">
          </app-ds-typography>
        </span>
      </div>
      <div class="room">
        <div class="room-info" *ngFor="let room of rooms; index as roomIndex">
          <app-ds-typography
            [fontFamily]="fontFamily.SemiBold" 
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [text]="('HOTELS_MODULE.HOTEL_RESERVATION.ROOM' | transloco) + ' ' + (roomIndex + 1)">
          </app-ds-typography>
          <div>
            <app-ds-typography
              [fontFamily]="fontFamily.Regular" 
              [size]="fontSize.XXS"
              [color]="fontColor.Primary"
              [text]="room.Description">
            </app-ds-typography>
            <app-ds-typography
              [fontFamily]="fontFamily.Regular" 
              [size]="fontSize.XXS"
              [color]="fontColor.Primary"
              [text]="room.BoardDescription">
            </app-ds-typography>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #detailByhours>
    <div class="registration">
      <div class="check-in">
        <h3 class="title">{{'HOTELS_MODULE.HOTEL_RESERVATION.CHECK_IN' | transloco }}</h3>
        <span>{{checkinDate | date:'EEEE, d MMM yyyy'}}</span>
      </div>
      <div class="room-info">
        <h3 class="title">{{'HOTELS_MODULE.HOTEL_RESERVATION.ROOM' | transloco }} 1</h3>
        <div>
          <span>{{rooms[0].Description}}</span>
          <span>{{rooms[0].BoardDescription}}</span>
        </div>
      </div>
    </div>
    <div class="registration">
      <div class="check-in">
        <h3 class="title">{{'HOTELS_MODULE.HOTEL_RESERVATION.CHECK_IN' | transloco }}</h3>
        <span>{{checkin | date:'HH:mm'}}</span>
      </div>
      <div class="check-out">
        <h3 class="title">{{'HOTELS_MODULE.HOTEL_RESERVATION.CHECK_OUT' | transloco }}</h3>
        <span>{{checkout | date:'HH:mm'}}</span>
      </div>
      <div class="hours">
        <h3 class="title">{{'BOOKING_MODULE.FLIGHT_TRIP.STAY' | transloco }}</h3>
        <span>{{'HOTELS_MODULE.DETAIL_DESCRIPTION.HOURS'| transloco: { hours: packHours } }}</span>
      </div>
    </div>
  </ng-template>
</div>
